module.exports = __webpack_public_path__ + "static/img/alipay.b31c25b0.jpg";